export default __webpack_public_path__ + "static/media/A2.13e4a250.png";